<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Merchandising from "@/services/Merchandising";
import Http from "@/services/Http";
import Swal from "sweetalert2";
import ModalEditAppProduct from "../../../components/modals/merchandise/modalEditAppProduct.vue";
import ModalAddAppProduct from "../../../components/modals/merchandise/modalAddAppProduct.vue";
import ModalAddProductHighlightedImage from "../../../components/modals/merchandise/modalAddProductHighlightedImage.vue";
import Sortable from "sortablejs";

/**
 * Starter page
 */
export default {
  components: { Layout, PageHeader, ModalEditAppProduct,ModalAddAppProduct, ModalAddProductHighlightedImage },
  page: {
    title: "App Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  data() {
    return {
      title: "App Products",
      items: [
        {
          text: "App Products",
          href: "/",
        },
      ],
      filterData: false,
      showPublished: true,
      showUnpublished: true,
      isBusy: false,
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "created_at",
      hasHighlighted:false,
      modalData:[],
      sortDesc: true,
      fields: [
        { key: "order",          label: "Order",          col: "col-1" },
        { key: "title",          label: "Title",          col: "col-2" },
        { key: "price",          label: "Price",          col: "col-1" },
        { key: "discount_price", label: "Discount Price", col: "col-1" },
        { key: "image_url",      label: "Image",          col: "col-1" },
        { key: "is_published",   label: "Published",      col: "col-1" },
        { key: "is_highlighted", label: "Highlighted",    col: "col-1" },
        { key: "landingpage_url",label: "Product Link",   col: "col-3" },
        { key: "actions",        label: "Actions",        col: "col-1" },
      ],
      sortableInstance: null,

    };
  },
  middleware: "authentication",
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
    highlightedProductId() {
      const highlighted = this.tableData.find(p => p.is_highlighted == 1)
      return highlighted ? highlighted.id : null
    },
    sortedTableData() {
      return [...this.tableData].sort((a, b) => {
        const aPriority = a.is_published && a.is_highlighted;
        const bPriority = b.is_published && b.is_highlighted;

        if (bPriority !== aPriority) return bPriority - aPriority

        return a.order - b.order
      })
    },
    tableHeaders() {
      return this.tableData.length ? Object.keys(this.tableData[0]) : [];
    },
    filteredTableData() {
      return this.tableData.filter(product => {
        if (this.showPublished && this.showUnpublished) return true;
        if (this.showPublished && product.is_published == 1) return true;
        if (this.showUnpublished && product.is_published == 0) return true;
        return false;
      })
    },
   
  },
  mounted() {
    // Set the initial number of items
    this.getAppProducts();
    this.totalRows = this.items.length;
    // this.initSortable();
  },



  methods: {

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    openModalEditAppProducts(data){
       this.modalData = data;
       this.$bvModal.show('edit_app_products') 
    },

    openModalAddAppProducts(){
       this.$bvModal.show('add_app_products') 
    },

    openModalAddHighlight(data,status){
      this.modalData = {
        ...data,
        is_highlighted: status ? 1 : 0
      }

      // if(data.image_highlighted_url == '' || data.image_highlighted_url == null){
      if(!data.image_highlighted_url){
        this.$bvModal.show('add_app_product_highlight');
      }else{
        this.changeHighlightedStatus(
          data.is_highlighted == 1 ? 0 : 1,
          data.id
        )    
        }

    },

    openModalAddHighlightImage(data) {
      this.modalData = data;
      this.$bvModal.show('add_app_product_highlight');

    },

    async changePublishedStatus(status,productId){
        try{
            let formData = new FormData();
            formData.append("is_published",status)
            formData.append("_method","PATCH");

            const response = await Merchandising.editAppProduct(formData,productId);
            if(response.success == false){
              Swal.fire("Error",response.error || "Failed to update product published status. Please try again","error");
            }else{
              Swal.fire("Success","Product edited successfully!","success");
              this.getAppProducts();
            }

        }catch(error){
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error)
          console.error(this.error);
          this.getAppProducts()
        }
    },

    async changeHighlightedStatus(status, productId) {
      try {
        let formData = new FormData();
        formData.append("is_highlighted", status)
        formData.append("_method", "PATCH");

        const response = await Merchandising.editAppProduct(formData, productId);
        if (response.success == false) {
          Swal.fire("Error", response.error || "Failed to update product published status. Please try again", "error");
        } else {
          Swal.fire("Success", "Product edited successfully!", "success");
          this.getAppProducts();
        }

      } catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
        this.failedmsg(this.error)
        console.error(this.error);
        this.getAppProducts()
      }
    },


    async getAppProducts() {
      try {
        this.filterData = true;
        this.isBusy = true;
        let filters = this.getFilters()
        const response = await Merchandising.getAppProducts(filters)
        this.tableData = response.data.products.sort((a, b) => a.order - b.order);
        this.isBusy = false;
        this.$nextTick(() => {
          this.initSortable()
        })

      }
      catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = [];
        this.isBusy = false;
      }
    },

     initSortable() {
      this.$nextTick(() => {
        const container = document.getElementById('products_list');
        if (container) {
          // Destroy existing instance if any
          if (this.sortableInstance) {
            this.sortableInstance.destroy();
          }

          this.sortableInstance = Sortable.create(container, {
            handle: '.drag-handle',
            animation: 150,
            ghostClass: 'sortable-ghost',
            filter: '.no-drag',
            preventOnFilter: false,
            onMove: (evt) => {
              // Only pin position 0 when the highlighted product is actually the
              // first visible row. Under a filter (e.g. "Unpublished only") the
              // highlighted/published product is hidden, so there's nothing to
              // protect and dropping into first place must be allowed.
              const firstVisible = this.filteredTableData[0];
              const highlightedIsFirst =
                  firstVisible &&
                  firstVisible.id === this.highlightedProductId &&
                  firstVisible.is_published;

              if (highlightedIsFirst) {
                // Get all direct children of the container
                const children = Array.from(container.children);
                const relatedIndex = children.indexOf(evt.related);

                // Block dropping at index 0 (before highlighted item)
                if (relatedIndex === 0 && !evt.willInsertAfter) {
                  return false;
                }
              }
            },
            onEnd: async (evt) => {
              if (
                  evt.oldIndex == null ||
                  evt.newIndex == null ||
                  evt.oldIndex === evt.newIndex
              ) {
                return;
              }

              // Undo the DOM move SortableJS just made so Vue stays the single
              // source of truth. Without this, SortableJS's real DOM and Vue's
              // virtual DOM desync after the first drag, and the next drag
              // reports stale indices — making the payload resend the old order.
              const parent = evt.from;
              if (evt.oldIndex < evt.newIndex) {
                parent.insertBefore(evt.item, parent.children[evt.oldIndex]);
              } else {
                parent.insertBefore(evt.item, parent.children[evt.oldIndex + 1]);
              }

              // 1. Reorder within the visible (filtered) list — the indices
              //    from SortableJS are relative to what the DOM rendered.
              const visible = [...this.filteredTableData];
              const [movedItem] = visible.splice(evt.oldIndex, 1);
              visible.splice(evt.newIndex, 0, movedItem);

              // 2. Drop the reordered visible items back into the slots they
              //    occupy in the full array; hidden items stay where they are.
              const visibleIds = new Set(visible.map(p => p.id));
              let v = 0;
              this.tableData = this.tableData.map(item =>
                  visibleIds.has(item.id) ? visible[v++] : item
              );

              // 3. Recompute order across the full list.
              const tableDataOrder = this.tableData.map((item, index) => {
                item.order = index + 1;
                return {
                  id: item.id,
                  order: item.order,
                }
              })

              const payload = {
                "order": tableDataOrder
              }

              const response = await Merchandising.orderAppProducts(payload);
              if (response.data && response.data.products) {
                this.tableData = response.data.products.sort((a, b) => a.order - b.order);
              }
            }
          });
        }
      });
    },





    getFilters() {
      var filter_string = '&limit=1000';
      filter_string += '&is_published=all';
      // filter_string += (this.filterInput.product_name) ? '&name=' + this.filterInput.product_name : "";
      // filter_string += (this.selectedCategoryId) ? '&category_id=' + this.selectedCategoryId : "";
      // //            filter_string += (this.filterInput.tag) ? '&tag=' + this.filterInput.tag : "";
      // filter_string += (this.filterInput.withpic) ? '&withpic=' + this.filterInput.withpic : "";
      return filter_string = filter_string.substring(1);
    },

    async deleteAppProduct(productId) {

      Swal.fire({
        title: "Delete App Product?",
        text: "This App Product will be deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete"
      }).then(async (result) => {
        if (result.isConfirmed === true) {
          try {
            const response = await Merchandising.deleteAppProduct(productId);
            if (response.data.success) {
              Swal.fire("Success!", "App Porduct is successfully deleted!", "success");
              await this.getAppProducts();
            } else {
              const error = response.error ? response.error : 'Failed';
              Swal.fire("Fail!", error, "warning");
            }
          } catch (error) {
            this.error = error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "An error occurred while removing the product.";
            Swal.fire("Error", this.error, "error");
          }

        }
      })
    },

    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 50000,
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-show="filterData">
      <div class="col-12">

        <div class="card">
          <div class="card-body">
            <div class="row align-items-center gap-4">
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light mb-2 ms-2 col-2" @click="openModalAddAppProducts()">
                Add Product
              </a>
              <div class="col-8 row">
                <div class="col-2">
                  <div class="form-check mb-3">
                    <input
                        v-model="showPublished"
                        type="checkbox"
                        class="cursor-pointer form-check-input"
                        id="filterPublished"
                    />
                    <label class="form-check-label" for="filterPublished">Published</label>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-check mb-3">
                    <input
                        v-model="showUnpublished"
                        type="checkbox"
                        class="cursor-pointer form-check-input"
                        id="filterUnpublished"
                    />
                    <label class="form-check-label" for="filterUnpublished">Unpublished</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filters End -->
            <div class="row mt-4">
            </div>
            <div v-if="isBusy" class="text-center my-4">
              <b-spinner variant="primary" label="Loading..."></b-spinner>
            </div>

            <div v-else id="app_products_table">

              <div id="table_header" class="card d-flex flex-row align-items-center px-4 py-1 mb-4" v-if="tableData.length && !isBusy" style="font-size: 0.75rem;  letter-spacing: 0.05em; border-top: 1px solid #f5f6f8; border-bottom: 1px solid #f5f6f8;">
                <div class="drag-handle me-3 flex-shrink-0" style="visibility:hidden; cursor: move;"><i class="uil uil-bars" style="font-size: 18px; color: rgb(108, 117, 125);"></i></div>
                <div class="row flex-grow-1 g-0 align-items-center mx-0">
                  <div v-for="field in fields" :key="field.key" :class="field.col">{{ field.label }}</div>
                </div>
              </div>
              <div id="products_list">
                <div class="mb-3" v-for="(product) in filteredTableData" :key="product.id">
                  <div :class="{'highlighted no-drag':highlightedProductId === product.id && product.is_published}" class="card mb-5 px-3 d-flex flex-row align-items-center" >
                    <div class="drag-handle me-3 flex-shrink-0" style="cursor: move;">
                      <i class="uil uil-bars" style="font-size: 18px; color: #6c757d;"></i>
                    </div>
                    <div class="row flex-grow-1 g-0 align-items-center mx-0">
                    <div class="col-1">
                      <p class="text-muted m-0">{{product.order}}</p>
                    </div>

                    <!--title start-->
                    <div class="col-2">
                      <p class="text-muted m-0 text-truncate">{{product.title}}</p>
                    </div>
                    <!--title end-->

                    <!--price start-->
                    <div class="col-1">
                      <p class="text-muted m-0">{{product.price}}</p>
                    </div>
                    <!--price end-->

                    <!--discount_price start-->
                    <div class="col-1">
                      <p class="text-muted m-0">{{product.discount_price}}</p>
                    </div>
                    <!--discount_price end-->

                    <!--image_url start-->
                    <div class="col-1">
                      <img v-if="product.image_url" :src="product.image_url" :alt="product.title" style="width: 100%; max-width: 70px; height: auto;" />
                      <img v-else src="../../../assets/images/image_not_found.png" style="width: 100%; max-width: 60px; height: auto;"/>
                    </div>
                    <!--image_url end-->

                    <!--is_published start-->
                    <div class="col-1">
                      <div class="form-check form-switch form-switch-lg mb-0">
                        <input @change="changePublishedStatus(product.is_published,product.id)"
                               v-model="product.is_published" type="checkbox" class="cursor-pointer form-check-input"
                               id="switch1" true-value="1"
                               false-value="0"/>
                      </div>
                    </div>
                    <!--is_published end-->

                    <!-- is_highlightes start-->
                    <div class="col-1">
                      <div class="d-flex">
                        <div :title="highlightedProductId && product.id !== highlightedProductId
                                          ? 'Only one product can be highlighted'
                                          : ''
                                        " class="cursor-pointer form-check form-switch form-switch-lg mb-0">
                          <input
                              type="checkbox"
                              class="cursor-pointer form-check-input"
                              :checked="product.is_highlighted == 1"
                              @click.prevent="openModalAddHighlight(product, product.is_highlighted == 0)"
                              :disabled="highlightedProductId && product.id !== highlightedProductId"
                              id="switch1" true-value="1" false-value="0"
                          />
                        </div>
                        <div v-if="product.is_highlighted == 1 && product.image_highlighted_url !== ''">
                          <i @click="openModalAddHighlightImage(product)" title="Edit Highlihted Image"
                             class="cursor-pointer uil uil-image font-size-18 text-primary"></i>
                        </div>
                      </div>
                    </div>
                    <!-- is_highlighted end -->

                    <!--landingpage_url start-->
                    <div class="col-3">
                      <a :href="product.landingpage_url" target="_blank" class="text-truncate d-block">{{ product.landingpage_url }}</a>
                    </div>
                    <!--landingpage_url end-->

                    <!--Actions start-->
                    <div class="col-1">
                      <ul class="list-inline mb-0 d-flex">
                        <li class="list-inline-item" title="Edit App Product">
                          <i class="cursor-pointer uil uil-pen font-size-18 text-primary"
                             @click="openModalEditAppProducts(product)"></i>
                        </li>
                        <li class="list-inline-item" title="Delete App Product">
                          <i class="cursor-pointer uil uil-trash-alt font-size-18 text-danger"
                             @click="deleteAppProduct(product.id)"></i>
                        </li>
                      </ul>
                    </div>
                    <!--Actions end-->
                    </div>

                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
    <ModalAddAppProduct @onRefresh="getAppProducts()"></ModalAddAppProduct>
    <ModalEditAppProduct :appProduct="modalData" @onRefresh="getAppProducts()"></ModalEditAppProduct>
    <ModalAddProductHighlightedImage :appProduct="modalData" @onRefresh="getAppProducts()"></ModalAddProductHighlightedImage>
  </Layout>
</template>
<style>
.highlighted{
  border: 1px solid #ADD8E6;
  background-color: #F8F9FA;
}

#app_products_table [class*="col-"] {
  padding-top: 0;
}
</style>